import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@mui/material/Box';
import Header from '../header/Header';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Swal from 'sweetalert2';
import { styled } from '@mui/material/styles';
import { API_URL } from '../../Constants';
import { createTheme, ThemeProvider } from '@mui/material/styles';


const ButtonPrincipal = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    '&:hover': {
        backgroundColor: '#BADEC1',
    },
});

const useStyles = makeStyles((theme) => ({
    pramiTypography: {
        fontFamily: 'Roboto+Mono:ital,wght@1,100'
    },
    containerStyle: {
        background: 'linear-gradient(#FFFFFF, #a6d1aa)'
    }

}));



const theme = createTheme({
    palette: {
        primary: {
            main: '#0e1853'
        }
    },

});

const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

function showSuccessCreated() {

    Swal.fire({
        icon: 'success',
        title: 'Solicitud Realizada!',
        showConfirmButton: false,
        timer: 1500
    });
    sleep(1500).then(() => {
        window.location.replace('https://www.prami.com.co/');
    })
}

const handlePotentialClient = () => {

    let apiUrl = API_URL;

    let commerceName = document.getElementById("commerceName").value;
    let clientName = document.getElementById("clientName").value;
    let clientCellphone = document.getElementById("clientCellphone").value;
    let clientEmail = document.getElementById("clientEmail").value;
    if (commerceName != "" && clientName != "" && (clientCellphone != "" || clientEmail != "")) {
        let potentialClientRequest = {
            "commerceName": commerceName,
            "fullName": clientName,
            "cellphone": clientCellphone,
            "email": clientEmail
        }
        fetch(apiUrl + '/v1/potential-clients/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json ',
                'Accept': 'application/json',
            },
            body: JSON.stringify(potentialClientRequest),
        }).then(function (response) {
            if (response.ok) {
                response.json().then(function (res) {
                    console.log(res.uuid)
                });
                showSuccessCreated();
            } else {
                alert("Por favor contacte al administrador")
            }

        }).catch(function (error) {
            console.log('Hubo un problema con la petición Fetch:' + error.message);
        });
    } else {
        alert("Por favor revisar los campos faltantes")
    }

}

export default function LandingPage() {

    const classes = useStyles();

    return (
        <React.Fragment>
            <Header isLoggedIn={false} />
            <ThemeProvider theme={theme}>
                <Container maxWidth="false" className={classes.containerStyle}>
                    <Container maxWidth="lg" className={classes.containerStyle} >
                        <br />
                        <br />
                        <br />
                        <Box sx={{ height: '300%', flexGrow: 1 }} >
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={12}>
                                    <Typography variant="h3" gutterBottom color={'#0e1853'} align='center' className={classes.pramiTypography}>
                                        ¿Quieres convertirte en un aliado Prami?
                                    </Typography>
                                    <br />
                                    <br />
                                </Grid>
                                <Grid item xs={12} md={2.5}> </Grid>
                                <Grid item xs={12} md={7}>
                                    <Stack spacing={3}>
                                        <Typography variant="h5" gutterBottom color={'#0e1853'}>
                                            Déjanos tus datos y te contactaremos lo más pronto posible
                                        </Typography>

                                        <TextField required id="commerceName" label="Nombre de tu comercio / Razon Social " variant="outlined"
                                            style={{ background: 'white', borderRadius: '5px' }}
                                        />
                                        <TextField required id="clientName" label="Tu Nombre" variant="outlined"
                                            style={{ background: 'white', borderRadius: '5px' }}
                                        />
                                        <TextField required id="clientCellphone" label="Tu Celular" variant="outlined"
                                            style={{ background: 'white', borderRadius: '5px' }}
                                        />
                                        <TextField required id="clientEmail" label="Tu Correo Electronico" variant="outlined"
                                            style={{ background: 'white', borderRadius: '5px' }}
                                        />
                                        <Typography variant="h9" gutterBottom color={'#0e1853'}>
                                            Al registrarse, acepta que su información personal sea administrada según los términos de la
                                            <a href="https://www.prami.com.co/wp-content/uploads/2022/03/POLITICA-DE-TRATAMIENTO-DE-DATOS-PERSONALES.pdf" target="_blank"> Política de privacidad </a>
                                            de Prami.
                                        </Typography>
                                        <Stack spacing={2} direction="row" >
                                            <Grid item xs={12} md={5}> </Grid>
                                            <Grid item xs={12} md={2} >
                                                <ButtonPrincipal variant="contained" onClick={handlePotentialClient}>Enviar</ButtonPrincipal>
                                            </Grid>
                                            <Grid item xs={12} md={5}> </Grid>

                                        </Stack>
                                    </Stack>
                                </Grid>
                                <Grid item xs={12} md={2.5}> </Grid>
                                <Grid item xs={12} md={12}>
                                    <Stack spacing={3}>
                                        <Stack spacing={2}>
                                            <Typography variant="h4" gutterBottom align='center' color={'#0e1853'}>
                                                Aumenta ventas ofreciendo medios de financiación a tus clientes
                                            </Typography>
                                            <h1></h1>
                                            <h1></h1>
                                            <br />
                                            <br />
                                            <h1></h1>
                                            <h1></h1>
                                        </Stack>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Box>

                    </Container>
                </Container>
            </ThemeProvider>

        </React.Fragment>
    );
}